import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import useFetch from './hooks/useFetch';
import { update } from './services/upload-files.service';
import EditUserDetails from './EditUserDetails';
import EditPersonalInformation from './EditPersonalInformation';
import EditCompanyInformation from './EditCompanyInformation';


export default function Editprofile() {

  const [formData, setFormData] = useState({})
  const [loading, setLoading] = useState(false)
  const [validationErrors, setValidationErrors] = useState({});
  const userdetails = JSON.parse(localStorage.getItem('userdetails'));
  const { data, isLoading } = useFetch(`users/profile/${userdetails.id}`);
  const [activeTab, setActiveTab] = useState("user-details");

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };


  useEffect(() => {
    if (data) {
       localStorage.setItem('company_logo', data.company_info?.company_logo);
      setFormData(data);
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    const [section, field] = name.split('__');

    if (e.target.type === 'file') {
      setFormData((prevData) => ({
        ...prevData,
        [section]: {
          ...prevData[section],
          [field]: files[0]
        }
      }))
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [section]: {
          ...prevData[section],
          [field]: value
        }
      }));
    }

    setValidationErrors((prevErrors) => ({
      ...prevErrors, [section]: {
        ...prevErrors[section],
        [field]: ''
      }
    }))
  };


  if (isLoading || loading) {
    return (
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
        </div>
      </main>
    );
  }

  return (
    <>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2">Edit Profile</h1>
        </div>

        <nav>
          <div className="nav nav-tabs team-mngmt-tab" id="nav-tab" role="tablist">
            <button
              className={`nav-link ${activeTab === 'user-details' ? 'active' : ''}`}
              id="nav-department-tab"
              data-bs-toggle="tab"
              type="button"
              role="tab"
              aria-controls="nav-department"
              aria-selected={activeTab === 'user-details'}
              onClick={() => toggleTab('user-details')}
            >
              <b>User Details</b>
            </button>
            <button
              className={`nav-link ${activeTab === 'personal-information' ? 'active' : ''}`}
              id="nav-employee-tab"
              data-bs-toggle="tab"
              type="button"
              role="tab"
              aria-controls="nav-employee"
              aria-selected={activeTab === 'personal-information'}
              onClick={() => toggleTab('personal-information')}
            >
              <b>Personal Information</b>
            </button>
            {(localStorage.getItem('userdetails') !== null && JSON.parse(localStorage.getItem('userdetails')).role_name === "SUPERADMIN") ?
              <>
                <button
                  className={`nav-link ${activeTab === 'company-information' ? 'active' : ''}`}
                  id="nav-supplier-tab"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  aria-controls="nav-supplier"
                  aria-selected={activeTab === 'company-information'}
                  onClick={() => toggleTab('company-information')}
                >
                  <b>Company Information</b>
                </button>
              </>
              : ""
            }

          </div>
        </nav>



        <div className="tab-content" id="nav-tabContent">
          <EditUserDetails activeTab={activeTab} handleInputChange={handleInputChange} formData={formData} validationErrors={validationErrors} setLoading={setLoading} setFormData={setFormData} userdetails={userdetails} />


          <EditPersonalInformation activeTab={activeTab} handleInputChange={handleInputChange} formData={formData} validationErrors={validationErrors} setLoading={setLoading} setFormData={setFormData} userdetails={userdetails} />


          <EditCompanyInformation activeTab={activeTab} handleInputChange={handleInputChange} formData={formData} validationErrors={validationErrors} setLoading={setLoading} setFormData={setFormData} userdetails={userdetails} />

        </div>






        {/* <div className='row'>
          <div className='col-4'>
            <div className='editprofile'> */}
        {/* <h4>User Details</h4>
              <hr></hr> */}
        {/* <Form onSubmit={handleSubmit}> */}
        {/* <Form.Group className="mb-3" controlId="fname">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="user__firstname"
                    value={formData.user ? formData.user.firstname || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.user && <div className="error login-error">{validationErrors.user.firstname}</div>}

                </Form.Group>
                <Form.Group className="mb-3" controlId="lname">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="user__lastname"
                    value={formData.user ? formData.user.lastname || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.user && <div className="error login-error">{validationErrors.user.lastname}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="contact">
                  <Form.Label>Contact no</Form.Label>
                  <Form.Control
                    type="text"
                    name="user__contact"
                    value={formData.user ? formData.user.contact || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.user && <div className="error login-error">{validationErrors.user.contact}</div>}
                </Form.Group> */}

        {/* <h4>Personal Information</h4>
                <hr></hr> */}
        {/* <Form.Group className="mb-3" controlId="fname">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="personal_info__firstname"
                    value={formData.personal_info ? formData.personal_info.firstname || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.firstname}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="lname">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="personal_info__lastname"
                    value={formData.personal_info ? formData.personal_info.lastname || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.lastname}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="cno">
                  <Form.Label>Contact no</Form.Label>
                  <Form.Control
                    type="text"
                    name="personal_info__mobile"
                    value={formData.personal_info ? formData.personal_info.mobile || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.mobile}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="city">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="personal_info__city"
                    value={formData.personal_info ? formData.personal_info.city || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.city}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="state">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    type="text"
                    name="personal_info__state"
                    value={formData.personal_info ? formData.personal_info.state || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.state}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="country">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    type="text"
                    name="personal_info__country"
                    value={formData.personal_info ? formData.personal_info.country || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.country}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="pcode">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="text"
                    name="personal_info__pin"
                    value={formData.personal_info ? formData.personal_info.pin || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.pin}</div>}
                </Form.Group>
 */}

        {/* <h4>Company Information</h4>
              <hr></hr> */}
        {/* <Form.Group className="mb-3" controlId="fname">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="company_info__name"
                    value={formData.company_info ? formData.company_info.name || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.name}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="lname">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    name="company_info__phone"
                    value={formData.company_info ? formData.company_info.phone || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.phone}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="cemail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    name="company_info__email"
                    value={formData.company_info ? formData.company_info.email || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.email}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="city">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="company_info__city"
                    value={formData.company_info ? formData.company_info.city || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.city}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="state">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    type="text"
                    name="company_info__state"
                    value={formData.company_info ? formData.company_info.state || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.state}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="country">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    type="text"
                    name="company_info__country"
                    value={formData.company_info ? formData.company_info.country || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.country}</div>}
                </Form.Group>
                <Form.Group className="mb-3" controlId="pcode">
                  <Form.Label> Pincode </Form.Label>
                  <Form.Control
                    type="text"
                    name="company_info__pin"
                    value={formData.company_info ? formData.company_info.pin || '' : ''}
                    onChange={handleInputChange}
                  />
                  {validationErrors.company_info && <div className="error login-error">{validationErrors.company_info.pin}</div>}
                </Form.Group> */}
        {/* <button class="btn btn-primary btn-add mb-3" type='submit'>  Save</button>
              </Form> */}
        {/* </div>
          </div> */}
        {/* <div className='col-4'>
            <div className='editprofile'>
              <h4>Personal Information</h4>
              <Form>
                <Form.Group className="mb-3" controlId="fname">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control type="text" value='eva' />
                </Form.Group>
                <Form.Group className="mb-3" controlId="lname">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control type="text" value="adam" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="cno">
                  <Form.Label>Contact no</Form.Label>
                  <Form.Control type="text" value="9768709676" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="city">
                  <Form.Label>City</Form.Label>
                  <Form.Control type="text" value="new jersey" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="state">
                  <Form.Label>State</Form.Label>
                  <Form.Control type="text" value="new jersey" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="country">
                  <Form.Label>Country</Form.Label>
                  <Form.Control type="text" value="US state" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="pcode">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control type="text" value="400103" />
                </Form.Group>
                <button class="btn btn-primary btn-add mb-3" disabled>  Save</button>
              </Form>
            </div>
          </div> */}
        {/* <div className='col-4'>
            <div className='editprofile'>
              <h4>Company Information</h4>
              <Form>
                <Form.Group className="mb-3" controlId="fname">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="text" value='LSInextgen pvt ltd' />
                </Form.Group>
                <Form.Group className="mb-3" controlId="lname">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control type="text" value="987654321" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="cemail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="text" value="info@lsinextgen.com" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="cno">
                  <Form.Label>Contact no</Form.Label>
                  <Form.Control type="text" value="9768709676" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="city">
                  <Form.Label>City</Form.Label>
                  <Form.Control type="text" value="new jersey" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="state">
                  <Form.Label>State</Form.Label>
                  <Form.Control type="text" value="new jersey" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="country">
                  <Form.Label>Country</Form.Label>
                  <Form.Control type="text" value="US state" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="pcode">
                  <Form.Label> Pincode </Form.Label>
                  <Form.Control type="text" value="400103" />
                </Form.Group>
                <button class="btn btn-primary btn-add mb-3" disabled>  Save </button>
              </Form>
            </div>
          </div> */}
        {/* </div> */}
      </main>
    </>
  )
}
